export const PAYSTUBS_DEFAULT_YEAR = "2026";
export const PAYSTUBS_YEARS = ["2024", "2025", "2026"] as const;
